import { StocktakeItemInfo, StocktakeInfo } from "../../models/models";
import { getEmptyStocktake } from './Stocktake';
import { getEmptyStore } from './Store';

export function getEmptyStocktakeInfo(): StocktakeInfo
{
		return {
			stocktake: getEmptyStocktake(),
			items: [] as StocktakeItemInfo[],
			store: getEmptyStore(),
		}
}
